export default function Settings() {
    return (
      <div className="p-6 max-w-3xl space-y-6">
        <h1 className="text-3xl font-semibold">Settings</h1>
  
        {/* Profile Section */}
        <div className="bg-white p-6 rounded-xl shadow border">
          <h2 className="text-xl font-semibold mb-4">Profile Settings</h2>
  
          <div className="space-y-3">
            <input
              placeholder="Full Name"
              className="border p-2 rounded w-full"
            />
            <input
              placeholder="Email"
              className="border p-2 rounded w-full"
            />
            <input
              placeholder="Phone Number"
              className="border p-2 rounded w-full"
            />
          </div>
  
          <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded">
            Save Changes
          </button>
        </div>
  
        {/* System Settings */}
        <div className="bg-white p-6 rounded-xl shadow border">
          <h2 className="text-xl font-semibold mb-4">System Preferences</h2>
  
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="font-medium">Dark Mode</span>
              <input type="checkbox" className="w-6 h-6" />
            </div>
  
            <div className="flex items-center justify-between">
              <span className="font-medium">Notifications</span>
              <input type="checkbox" className="w-6 h-6" defaultChecked />
            </div>
          </div>
        </div>
      </div>
    );
  }
  